export default __webpack_public_path__ + "next-pwX.svg";